// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TyYX","content":"styles_content__3XQJz","tableWrap":"styles_tableWrap__1sqq2"};